import React from "react";
import { apiPut } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../../utils/helpers";

const OnboardingList = ({ user, page, sort, setSort, formsManager, getFormsManager, handleUserView, manager }) => {
  const { t } = useTranslation();
  const notification = useToastContext();

  const handelStatusChangeList = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeFormsStatus}/${item?.formType}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getFormsManager();
      }
    } catch (error) {
      console.log("error in get all onboarding list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="rounded-lg overflow-x-auto border relative ">
        <table className="text-xs text-left text-[#6c6c6c] w-full dark:text-gray-400 ">
          <thead className="dark:bg-gray-700 border border-[#E1E6EE] bg-[#E1E6EE] text-xs text-gray-900  dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th className="py-3 px-6" scope="col">
                {t("TITLE")}
              </th>
              <th
                className="px-6 cursor-pointer py-3 "
                onClick={() => {
                  const newSortType = sort.sortType === "asc" ? "desc" : "asc";
                  setSort({
                    sortBy: "createdAt",
                    sortType: newSortType,
                  });
                }}
                scope="col"
              >
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>{sort.sortBy === "createdAt" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
                </div>
              </th>
              {/* <th scope="col" className="py-3 text-center px-6 ">
                {t("O_STATUS")}
              </th> */}

              <th className="text-center py-3 px-6" scope="col">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {formsManager &&
              formsManager?.map((item, i) => (
                <tr key={i} className="dark:border-gray-700 bg-white border-b dark:bg-gray-800 ">
                  <th className="font-medium text-gray-900  py-4 px-6 border-r dark:text-white" scope="row">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="text-gray-900 py-4 px-6 border-r ">{item?.formName}</td>
                  <td className="px-6 border-r py-4 text-gray-900 ">{item?.createdAt ? dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A") : "N/A"}</td>

                  <td className="py-4 px-6 border-l text-gray-900">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.view || user?.role === "admin") && (
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue" onClick={() => handleUserView(item?._id)}>
                            <a title={t("VIEW_FORMS")}>
                              {" "}
                              <AiFillEye className="w-5 h-5 text-slate-600 cursor-pointer " />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(formsManager) ? (
              <tr className="border-b dark:bg-gray-800 bg-white text-center dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={5}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OnboardingList;
